<template>
  <a-drawer width="45%" :visible="open" @cancel="onClose" @close="onClose">
    <a-divider orientation="left">
      <b>{{ formTitle }}</b>
    </a-divider>
    <a-form-model ref="form" :label-col="labelCol" :wrapper-col="wrapperCol" :model="form" :rules="rules">
      <a-form-model-item :label="$t('用户实名认证.姓名')" prop="realName">
        <a-input v-model="form.realName" :placeholder="$t('通用.输入.请输入')+$t('用户实名认证.姓名')" />
      </a-form-model-item>
      <a-form-model-item :label="$t('用户实名认证.身份证号')" prop="idCard">
        <a-input v-model="form.idCard" :placeholder="$t('通用.输入.请输入')+$t('用户实名认证.身份证号')" />
      </a-form-model-item>
      <a-form-model-item :label="$t('用户实名认证.身份证人像面')" prop="idCardFront">
        <OssUploadSingle v-model="form.idCardFront" type="img" :maxSize="200" />
      </a-form-model-item>
      <a-form-model-item :label="$t('用户实名认证.身份证国徽面')" prop="idCardBack">
        <OssUploadSingle v-model="form.idCardBack" type="img" :maxSize="200" />
      </a-form-model-item>
      <a-form-model-item :label="$t('用户实名认证.审核状态')" prop="certificationStatus">
        <a-select :placeholder="$t('通用.输入.请选择')+$t('用户实名认证.审核状态')" v-model="form.certificationStatus" allowClear>
          <a-select-option v-for="(item, index) in customDict.UserRealNameStatusEnum" :value="item.type" :key="index">
            {{ item.name }}
          </a-select-option>
        </a-select>
      </a-form-model-item>
      <a-form-model-item :label="$t('用户实名认证.审核意见')" prop="certificationOpinion">
        <a-textarea v-model="form.certificationOpinion" :rows="3" :placeholder="$t('通用.输入.请输入')+$t('用户实名认证.审核意见')" />
      </a-form-model-item>
      <div class="bottom-control">
        <a-space>
          <a-button type="primary" :loading="submitLoading" @click="submitForm">
            {{$t('通用.按钮.保存')}}
          </a-button>
          <a-button type="dashed" @click="cancel">
            {{$t('通用.按钮.取消')}}
          </a-button>
        </a-space>
      </div>
    </a-form-model>
  </a-drawer>
</template>

<script>
import { getRealName, editRealName } from '@/api/userRealName/realName'
import { mapGetters } from 'vuex'
import OssUploadSingle from '@/components/OssUploadSingle'

export default {
  name: 'CreateForm',
  components: {
    OssUploadSingle
  },
  data () {
    return {
      labelCol: { span: 5 },
      wrapperCol: { span: 18 },
      submitLoading: false,
      formTitle: '',
      open: false,
      form: {
        id: null,
        realName: null,
        idCard: null,
        idCardFront: null,
        idCardBack: null,
        certificationStatus: null,
        certificationOpinion: null
      },
      rules: {
        realName: [
          { required: true, message: this.$t('用户实名认证.姓名') + this.$t('通用.文本.不能为空'), trigger: 'blur' }
        ],
        idCard: [
          { required: true, message: this.$t('用户实名认证.身份证号') + this.$t('通用.文本.不能为空'), trigger: 'blur' }
        ]
      }
    }
  },
  computed: {
    ...mapGetters(['customDict'])
  },
  methods: {
    onClose () {
      this.open = false
      this.reset()
    },
    cancel () {
      this.open = false
      this.reset()
    },
    reset () {
      this.form = {
        id: null,
        realName: null,
        idCard: null,
        idCardFront: null,
        idCardBack: null,
        certificationStatus: null,
        certificationOpinion: null
      }
    },
    /** 修改按钮操作 */
    handleUpdate (row) {
      this.reset()
      const id = row.id
      getRealName({ id: id }).then(response => {
        this.form = response.data
        this.open = true
        this.formTitle = this.$t('通用.文本.修改')
      })
    },
    /** 提交按钮 */
    submitForm: function () {
      this.$refs.form.validate(valid => {
        if (valid) {
          this.submitLoading = true
          editRealName(this.form).then(() => {
            this.$message.success(this.$t('通用.文本.修改成功'))
            this.open = false
            this.$emit('ok')
          }).finally(() => {
            this.submitLoading = false
          })
        } else {
          return false
        }
      })
    }
  }
}
</script>
